const translations = {
  "en": {
    "Extreme Fear": "Extreme Fear",
    "Extreme Greed": "Extreme Greed",
    "Fear": "Fear",
    "Fear & Greed Index": "Fear & Greed Index",
    "Greed": "Greed",
    "Neutral": "Neutral"
  },
  "zh-tw": {
    "Extreme Fear": "極度恐懼",
    "Extreme Greed": "極度貪婪",
    "Fear": "恐懼",
    "Fear & Greed Index": "恐懼與貪婪指數",
    "Greed": "貪婪",
    "Neutral": "中立"
  }
};

export default translations;
